/** store data in session storage */
export const SetSessionStorageData = (sessionKey: string, payload: any) => {
  return sessionStorage.setItem(sessionKey, payload);
};

/* To clear sessin storage */
export const clearSessionStorage = () => {
  return sessionStorage.clear();
};

/** get data from session storage */
export const GetSessionStorageData = (sessionKey: string) => {
  return sessionStorage.getItem(sessionKey);
};